/**
 * @generated SignedSource<<242b3c1970855c2eacd37345210fe551>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type webFormSubmissionsUtils_submissionUserFragment$data = {
  readonly user: {
    readonly fullName: string;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"ProfileAvatarFragment">;
  };
  readonly " $fragmentType": "webFormSubmissionsUtils_submissionUserFragment";
};
export type webFormSubmissionsUtils_submissionUserFragment$key = {
  readonly " $data"?: webFormSubmissionsUtils_submissionUserFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"webFormSubmissionsUtils_submissionUserFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "webFormSubmissionsUtils_submissionUserFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fullName",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProfileAvatarFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WebFormSubmission",
  "abstractKey": null
};

(node as any).hash = "d7bc5c528c6fb2816fb8488b119096d3";

export default node;
